import React from "react";
import PropTypes from "prop-types";
import { colors } from "./UploadCommon";

const ValidateStatusFlag = props => {
  const styles = {
    okColor: colors.ok,
    errorColor: colors.error,
    warningColor: colors.warning,
    statusBadge: {
      fontSize: "12px",
      fontFamily: "Roboto",
      display: "inline-block",
      fontWeight: "bold",
      color: "white",
      padding: "5px",
      minWidth: "20px",
      borderRadius: "10px",
      verticalAlign: "top",
      marginRight: "3px"
    }
  };

  return (
    <span
      style={{
        ...styles.statusBadge,
        backgroundColor: styles[`${props.type}Color`]
      }}
    >
      {props.children}
    </span>
  );
};
ValidateStatusFlag.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node
};
ValidateStatusFlag.defaultProps = {
  children: null
};
export default ValidateStatusFlag;
